import { blue, brightBlue, gray, red } from '~/common/styles/colors'
import { ButtonVariant } from '../../../atoms/button/types'

export const getLoadingSpinnerDisplay = (loading: boolean) => {
  if (loading) {
    return { display: 'block' }
  } else {
    return { display: 'none' }
  }
}

export const getContainerDisplay = (variant: ButtonVariant, loading: boolean) => {
  if (loading) {
    return { ...getLoadingContainerStyles(variant) }
  } else {
    return {}
  }
}

/**
 * Returns the loading styles for the button based on the variant
 */
export const getLoadingContainerStyles = (variant: ButtonVariant) => {
  switch (variant) {
    case 'primary':
      return {
        backgroundColor: blue[9],
        borderRadius: '4px',
      }
    case 'secondary':
      return {
        backgroundColor: gray[12],
        borderRadius: '4px',
      }
    case 'danger':
      return {
        backgroundColor: red[10],
        borderRadius: '4px',
      }
    case 'cta':
      return {
        backgroundColor: brightBlue,
        borderRadius: '4px',
      }
    case 'tertiary':
    case 'ghost':
    case 'true-ghost':
    case 'underline':
      return {
        color: 'transparent',
        borderRadius: '4px',
      }
  }
}
